export const ApproverRoutePath = {
  Prefix: "starter",
  Home: "/",
  Dashboard: "/dashboard",
  NotFoundError: "/404",
  InternalServerError: "/500",
};
